import { ApiService }            from '../../app-lite/api/api.service';
import { BursonServiceAjs }         from './burson.service.ajs';
import { CompanyIntegrationsModel } from '../../app-lite/companies/models/company.integrations';
import { SessionService }        from '../../app-lite/sessions/session.service';
import { UserModel }                from '../../app-lite/users/models/user';

import BursonSettingsHtml from './burson.settings.html';

export function BursonStates (
  $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'BursonSettingsCtrl',
    name       : 'app.burson-settings',
    templateUrl: BursonSettingsHtml,
    url        : '/burson_settings',
    resolve    : {
      session : ( sessionObjAPI : SessionService ) : ng.IPromise<any> => sessionObjAPI.refresh(),
      settings: ( bursonApi : BursonServiceAjs ) : ng.IPromise<CompanyIntegrationsModel> => bursonApi.getSettings(),
      user    : ( sessionObjAPI : SessionService, workshopAPI : ApiService ) : ng.IPromise<UserModel> => workshopAPI.get('/user', sessionObjAPI.user().id)
    }
  });
}